export default {
  bestsellers: {
    en: '<span aria-hidden="true">Great choice </span><b>Bestsellers</b>',
  },
  collections: {
    mobile: {
      male: {
        en: '<span aria-hidden="true">Need ideas? </span><b>Cologne Collections</b>',
      },
      female: {
        en: '<span aria-hidden="true">Need ideas? </span><b>Fragrance Collections</b>',
      },
    },
    desktop: {
      en: '<span aria-hidden="true">Need ideas? </span><b>Fragrance Playlists</b>',
    },
  },
  besidesFragrances: {
    mobile: {
      male: {
        en: '<span aria-hidden="true">Besides fragrances </span><b>Aroma Candles</b>',
      },
      female: {
        en: '<span aria-hidden="true">Besides fragrances </span><b>Makeup palettes</b>',
      },
    },
    desktop: {
      male: {
        en: '<span aria-hidden="true">More than fragrance </span><b>Scented candles</b>',
      },
      female: {
        en: '<span aria-hidden="true">More than fragrance </span><b>Makeup palettes</b>',
      },
    },
  },
  quiz: {
    en: '<span aria-hidden="true">Take our Quiz </span><b>Tailored recommendations</b>',
  },
  allMakeup: {
    en: '<span aria-hidden="true">More products </span><b>See all makeup products</b>',
  },
}
